import { useQuery, UseQueryOptions } from 'react-query'
import { useConvertElectricityMeters } from './electricitymeter.converter'
import { path } from 'ramda'

export const useElectricityMeters = (
  query?: any,
  options?: UseQueryOptions
) => {
  const { data, ...others } = useQuery(
    ['/device/electricitymeter/{pageNum}/{pageSize}', query],
    {
      cacheTime: 0,
      ...options,
    }
  )

  const dataSource = useConvertElectricityMeters(data)

  return {
    ...others,
    dataSource,
    loading: others.isLoading,
  }
}

//控制器型號
export const useElectricityControllerType = () => {
  const { data, refetch, isLoading, ...others } = useQuery(
    [`/device/electricitymeter/ctrler/types`],
    {
      select: (res: any) => path(['data'], res) as { ctrlerType: string }[],
    }
  )

  return {
    ...others,
    refetch,
    loading: isLoading,
    data,
  }
}
